
export default function formValidate() {
  //console.log('form validate');

  var returnUrl = document.getElementById('insurance-plans__quote-form-return');
  if (returnUrl) {
    var domain = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
    returnUrl.setAttribute('value', domain + returnUrl.value);
    //console.log(returnUrl.value, domain);
  }

  var returnUrl = document.getElementById('contact-form__form-return');
  if (returnUrl) {
    var domain = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
    returnUrl.setAttribute('value', domain + returnUrl.value);
    //console.log(returnUrl.value, domain);
  }

  document.querySelectorAll('.insurance-plans__quote-form input').forEach(el => {
    el.addEventListener('input', function (e) {
      //console.log('input', el.nextElementSibling);

      var form = document.querySelector('.insurance-plans__quote-form form');
      var formError = el.nextElementSibling;
      formError.innerHTML = '';
      formError.classList.remove('has-error');
    });
	});

  // quote form
  document.querySelectorAll('.insurance-plans__quote-form-btn input').forEach(el => {
    el.addEventListener('click', function (e) {

      e.preventDefault();

      var form = document.querySelector('.insurance-plans__quote-form form');
      //console.log(form);


      var formError = form.querySelectorAll('.input-group__error').forEach(error => {
        error.innerHTML = '';
        error.classList.remove('has-error');
      });


  		var constraints = {
  	    'name': {
  	      presence: true
  	    },
        'email': {
  	      presence: true,
          email: true
  	    },
        'phone': {
  	      presence: true
  	    }
  		};

      var errors = validate(form, constraints);
  		//console.log('errors', errors);

  		if (errors) {
        //console.log('has error');
        for (var constraint in constraints) {
          if (constraints.hasOwnProperty(constraint)) {
            //console.log(key + " -> " + p[key]);
            if (errors[constraint]) {
              var formError = form.querySelector('.input-group__error.' + constraint);
              //console.log('.input-group__error .' + constraint);
              formError.innerHTML = errors[constraint][0];
        			formError.classList.add('has-error');
            }
          }
        }
  		}
  		else {
        form.submit();
  		}

    });
	});

  document.querySelectorAll('.contact-form__form input').forEach(el => {
    el.addEventListener('input', function (e) {
      //console.log('input', el.nextElementSibling);

      var form = document.querySelector('.contact-form__form form');
      var formError = el.nextElementSibling;
      formError.innerHTML = '';
      formError.classList.remove('has-error');
    });
	});

  // contact form
  document.querySelectorAll('.contact-form__form-btn input').forEach(el => {
    el.addEventListener('click', function (e) {

      e.preventDefault();

      var form = document.querySelector('.contact-form__form form');
      //console.log(form);


      var formError = form.querySelectorAll('.input-group__error').forEach(error => {
        error.innerHTML = '';
        error.classList.remove('has-error');
      });


  		var constraints = {
  	    'name': {
  	      presence: true
  	    },
        'email': {
  	      presence: true,
          email: true
  	    },
        'phone': {
  	      presence: true
  	    }
  		};

      var errors = validate(form, constraints);
  		//console.log('errors', errors);

  		if (errors) {
        //console.log('has error');
        for (var constraint in constraints) {
          if (constraints.hasOwnProperty(constraint)) {
            //console.log(key + " -> " + p[key]);
            if (errors[constraint]) {
              var formError = form.querySelector('.input-group__error.' + constraint);
              //console.log('.input-group__error .' + constraint);
              formError.innerHTML = errors[constraint][0];
        			formError.classList.add('has-error');
            }
          }
        }
  		}
  		else {
        form.submit();
  		}

    });
	});


}
